import memoizeOne from 'memoize-one';
import { token } from '@atlaskit/tokens';
import messages from './messages.tsx';

/**
 * @deprecated Any changes made to this file should also be made to @atlassian/jira-issue-navigator-conditional-formatting-sidebar
 */
export const formattingColors: {
	[key: string]: {
		label: { id: string; defaultMessage: string; description: string };
		value: string;
		hoverValue: string;
	};
} = {
	lightPurple: {
		label: messages.lightPurple,
		value: token('color.background.accent.purple.subtlest'),
		hoverValue: token('color.background.accent.purple.subtlest.hovered'),
	},
	lightBlue: {
		label: messages.lightBlue,
		value: token('color.background.accent.blue.subtlest'),
		hoverValue: token('color.background.accent.blue.subtlest.hovered'),
	},
	lightGreen: {
		label: messages.lightGreen,
		value: token('color.background.accent.green.subtlest'),
		hoverValue: token('color.background.accent.green.subtlest.hovered'),
	},
	lightTeal: {
		label: messages.lightTeal,
		value: token('color.background.accent.teal.subtlest'),
		hoverValue: token('color.background.accent.teal.subtlest.hovered'),
	},
	lightYellow: {
		label: messages.lightYellow,
		value: token('color.background.accent.yellow.subtlest'),
		hoverValue: token('color.background.accent.yellow.subtlest.hovered'),
	},
	lightRed: {
		label: messages.lightRed,
		value: token('color.background.accent.red.subtlest'),
		hoverValue: token('color.background.accent.red.subtlest.hovered'),
	},
	lightGray: {
		label: messages.lightGray,
		value: token('color.background.accent.gray.subtlest'),
		hoverValue: token('color.background.accent.gray.subtlest.hovered'),
	},
	purple: {
		label: messages.purple,
		value: token('color.background.accent.purple.subtler'),
		hoverValue: token('color.background.accent.purple.subtler.hovered'),
	},
	blue: {
		label: messages.blue,
		value: token('color.background.accent.blue.subtler'),
		hoverValue: token('color.background.accent.blue.subtler.hovered'),
	},
	green: {
		label: messages.green,
		value: token('color.background.accent.green.subtler'),
		hoverValue: token('color.background.accent.green.subtler.hovered'),
	},
	teal: {
		label: messages.teal,
		value: token('color.background.accent.teal.subtler'),
		hoverValue: token('color.background.accent.teal.subtler.hovered'),
	},
	yellow: {
		label: messages.yellow,
		value: token('color.background.accent.yellow.subtler'),
		hoverValue: token('color.background.accent.yellow.subtler.hovered'),
	},
	red: {
		label: messages.red,
		value: token('color.background.accent.red.subtler'),
		hoverValue: token('color.background.accent.red.subtler.hovered'),
	},
	gray: {
		label: messages.gray,
		value: token('color.background.accent.gray.subtler'),
		hoverValue: token('color.background.accent.gray.subtler.hovered'),
	},
};

const nonAccessibleColors = new Set(['lightBlue', 'blue']);

/**
 * @deprecated Any changes made to this file should also be made to @atlassian/jira-issue-navigator-conditional-formatting-sidebar
 */
// We cannot remove the value from the mapping, as there are already rules with those colors in
// the backend, we are preventing any new rules to be created, we need to migrate existing rules
// to be able to remove it from the main object.
export const accessibleFormattingColors = Object.fromEntries(
	Object.entries(formattingColors).filter(([key]) => !nonAccessibleColors.has(key)),
);

/**
 * @deprecated Any changes made to this file should also be made to @atlassian/jira-issue-navigator-conditional-formatting-sidebar
 */
export const getColorKeyFromValue = memoizeOne((value: string) => {
	const selectedColor = Object.entries(formattingColors).find(
		([_, color]) => color.value.split(',')[0] === value.split(',')[0],
	);

	return selectedColor?.[0];
});
